/**
 * JSON Schema for the dump object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/Dump",
  type: "object",
  properties: {
    trace: { type: "string" },
    placeInCode: { type: "string" }
  }
};
